import { render, staticRenderFns } from "./ConnectUs.vue?vue&type=template&id=611262bc&scoped=true&"
import script from "./ConnectUs.vue?vue&type=script&lang=js&"
export * from "./ConnectUs.vue?vue&type=script&lang=js&"
import style0 from "./ConnectUs.vue?vue&type=style&index=0&id=611262bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611262bc",
  null
  
)

export default component.exports